module.exports = __webpack_public_path__ + "static/media/facebook-messenger.46535ad0.svg";